import { render, staticRenderFns } from "./ModelBoxUgly.vue?vue&type=template&id=33cfda3b&scoped=true&"
import script from "./ModelBoxUgly.vue?vue&type=script&lang=js&"
export * from "./ModelBoxUgly.vue?vue&type=script&lang=js&"
import style0 from "./ModelBoxUgly.vue?vue&type=style&index=0&id=33cfda3b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cfda3b",
  null
  
)

export default component.exports